import React from 'react';
import {connect} from 'react-redux';

export const BannerItemComponent = ({
    type,
    messages
}) => (
    <article className="banner-item">
        <header>
            <span className={`banner-icon banner-icon-${type}`} />
            <h2>{messages[type].title}</h2>
        </header>
        <p>{messages[type].text}</p>
    </article>
);

function mapStateToProps(state) {
    return {
        brandName: state.config.site.brandName,
        messages: state.modules.banner
    };
}

export const BannerItem =
    connect(mapStateToProps)(BannerItemComponent);
export default BannerItem;
